import ClockAnimation from "../../../img/svg/clockAnimation";

export default function AdminSpinner({ size = "md", className = "" }: { size?: "sm" | "md" | "lg", className?: string }) {

    const dimensions = size === "sm" ? "h-4 w-4" : size === "lg" ? "h-8 w-8" : "h-5 w-5";

    return (
        <span role="status" aria-label="Carregando" className={`inline-block shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent ${dimensions} ${className}`} />
    )
}

// carregamento de seção/página: mantém o relógio animado da marca, em tamanho discreto
export function AdminLoading({ className = "" }: { className?: string }) {
    return (
        <div className={`py-10 text-gray-500 ${className}`}>
            <ClockAnimation width="36px" fill="#6B7280" />
        </div>
    )
}
